"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCustomerRequest = exports.createCustomerRequest = exports.customerDto = exports.customerPersonType = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
/** B منشأة (فاتورة إلكترونية B2B)، P شخص (إيصال إلكترونى B2C). */
exports.customerPersonType = zod_1.z.enum(['B', 'P']);
/**
 * عميل الشركة. التعريف تشغيلى (اسم وتواصل ومدة سداد)، والرصيد لا يُخزَّن فيه:
 * يُحسب دائمًا من سطور حساب العملاء المنشورة الحاملة لمعرّفه.
 */
exports.customerDto = zod_1.z.object({
    id: common_1.uuid,
    companyId: common_1.uuid,
    /** كود يولّده الخادم بالتتابع (C-000001) — ثابت لا يتغير بتغير الاسم. */
    code: zod_1.z.string(),
    nameAr: zod_1.z.string(),
    personType: exports.customerPersonType,
    taxRegistrationNumber: zod_1.z.string().nullable(),
    phone: zod_1.z.string().nullable(),
    email: zod_1.z.string().nullable(),
    /** أيام السداد من تاريخ الفاتورة — يُشتق منها تاريخ الاستحقاق الافتراضى. */
    paymentTermsDays: zod_1.z.number().int(),
    isActive: zod_1.z.boolean(),
    createdAt: zod_1.z.string(),
});
const optionalText = (max) => zod_1.z
    .string()
    .trim()
    .max(max)
    .transform((value) => (value === '' ? null : value))
    .nullish();
/**
 * إنشاء عميل. رقم التسجيل الضريبى أرقام وشرطات فقط: صيغته الرسمية وطوله يُتحقق منهما
 * عند ربط الفاتورة الإلكترونية (BLOCKED-TAX) لا هنا.
 */
exports.createCustomerRequest = zod_1.z
    .object({
    nameAr: zod_1.z.string().trim().min(2, 'name must be at least 2 characters').max(200),
    personType: exports.customerPersonType.default('B'),
    taxRegistrationNumber: zod_1.z
        .string()
        .trim()
        .regex(/^[0-9-]*$/, 'tax registration number may contain digits and dashes only')
        .max(32)
        .transform((value) => (value === '' ? null : value))
        .nullish(),
    phone: optionalText(32),
    email: zod_1.z
        .string()
        .trim()
        .max(254)
        .refine((value) => value === '' || zod_1.z.string().email().safeParse(value).success, 'invalid email')
        .transform((value) => (value === '' ? null : value))
        .nullish(),
    paymentTermsDays: zod_1.z.number().int().min(0).max(365).default(0),
})
    .strict();
/**
 * تعديل بيانات العميل — الكود ثابت لأنه مرجع المستندات المطبوعة. الإيقاف بدل المسح
 * لعميل عليه حركات: يختفى من القوائم ويبقى كشف حسابه.
 */
exports.updateCustomerRequest = exports.createCustomerRequest
    .extend({ isActive: zod_1.z.boolean() })
    .strict();
//# sourceMappingURL=customer.js.map